import { useContext } from 'react';

import { cerise } from '@vimeo/iris/color';
import { StandardFooter } from '@vimeo/ui/core';
import { ViewerContext } from '@vimeo/viewer';

import TopNavigation from 'src/_components/Navigations/TopNavigation';

const HomePageLayout = ({ children }) => {
  const viewer = useContext(ViewerContext);
  return (
    <>
      <TopNavigation backgroundColor={cerise(40)} />
      {children}
      <StandardFooter {...viewer} absoluteUrl />
    </>
  );
};
export default HomePageLayout;
